<template>
  <div>
    <b-loading :active.sync="isLoading" :can-cancel="false" />

  <div v-if="!isLoading">

  <div class="columns is-vcentered">
    <div class="column is-7">
  <section class="hero is-bold">
    <div class="hero-body">
      <div class="container">
        <h1 class="title is-family-monospace">
          {{category.name}}
        </h1>
        <p class="subtitle is-family-code">
          <span class="has-text-weight-bold">{{category.meta_chunks_total_count | numeral('0a') }}+</span> feedbacks about <span class="has-text-weight-bold">{{category.meta_products_total_count}}</span> products<br />
        </p>
    </div>
    </div>
  </section>
  </div>
    <div class="column is-5">
      <category-mini-chart :category="category" height="150" />
    </div>
</div>

      <b-tabs :expanded="false">
          <b-tab-item label="Trends" icon="chart-line">
            <category-sentiment-trends-chart :category="category" title="What users dislike the most over time" sentiment="negative" />

          </b-tab-item>
          <b-tab-item label="Notable products" icon="apps">
            <products-table :category="category" />
          </b-tab-item>
          <b-tab-item label="Other" icon="" disabled></b-tab-item>
      </b-tabs>

</div>
</div>
</template>




<script>
import CategoryMiniChart from "@/charts/CategoryMiniChart"
import CategorySentimentTrendsChart from "@/charts/CategorySentimentTrendsChart"
import ProductsTable from "@/components/ProductsTable"


export default {
  name: 'Category',
  data() {
      return {
        category: null,
        isLoading: true,
        products: []
      }
  },
  methods: {
      getCategory: function() {
          this.isLoading = true

          this.url = `${this.$root.api_base_url}categories/${this.$route.params.id}/`


          this.$http.get(this.url)
              .then(({
                  data
              }) => {
              this.category = data
              })
              .catch((error) => {
                  this.data = []
                  this.$snackbar.open({
                      message: error,
                      type: "is-warning"
                  })
                  throw error
              })
              .finally(() => {
                  this.isLoading = false
              })
      },
      getProducts: function() {
          this.isLoading = true

          this.url = `${this.$root.api_base_url}products/?categories=${this.$route.params.id}&ordering=-meta_chunks_total_count`


          this.$http.get(this.url)
              .then(({
                  data
              }) => {
              this.products = data.results
              })
              .catch((error) => {
                  this.data = []
                  this.$snackbar.open({
                      message: error,
                      type: "is-warning"
                  })
                  throw error
              })
              .finally(() => {
                  this.isLoading = false
              })
      },

  },
  mounted: function() {
      this.getCategory();
      this.getProducts();
  },
  components: {
    CategoryMiniChart,
    CategorySentimentTrendsChart,
    ProductsTable
  }
}
</script>

<style scoped>
.hero .subtitle {
}
</style>

<style>

.tabs a {
  border: none;
}

</style>
